export enum SearchItems {
    Users = 'Users',
    OrgItems = 'OrgItems',
    DirectReports = 'DirectReports',
    Goals = 'Goals'
}